import {Controller, useForm} from "react-hook-form";
import React from "react";
import {patchResourceBrandData, postResourceBrandData} from "../../../api/apiBackoffice";

export const BrandDataForm = (props) => {

    const {successCallback, errorCallback, actualBrandData, setActualBrandData,
            setRightPartIsOpen} = props;

    const {handleSubmit, control, setValue} = useForm();

    const handleSubmitForm = async (data) => {
        if(actualBrandData === null) {
            // Create new Brand Data
            await postResourceBrandData(data)
                .then(() => {
                    setValue('name', '');
                    setRightPartIsOpen(false);
                    successCallback('La marque a été modifiée.');
                })
                .catch(() => errorCallback('Something went wrong.'));
        } else {
            // Update actual Brand Data
            data.id = actualBrandData.id;
            await patchResourceBrandData(data)
                .then(() => {
                    setValue('name', '');
                    setActualBrandData(null);
                    setRightPartIsOpen(false);
                    successCallback('La marque a été modifiée.');
                })
                .catch(() => errorCallback('Something went wrong.'));
        }
    };

    return(
        <>
            <h2 style={{"paddingLeft": "10px"}}>
                {actualBrandData !== null ? 'Modifier une marque de resource' : 'Ajouter une marque de resource'}
            </h2>
            <form onSubmit={handleSubmit(handleSubmitForm)} id="update-form">
                <label>Nom :</label>
                <div style={{"display": "flex", "justifyContent": "center", "marginBottom": "20px"}}>
                    <div>
                        <Controller
                            control={control}
                            name="name"
                            rules={{required: true}}
                            defaultValue={actualBrandData !== null ? actualBrandData.name : ''}
                            render={({field}) => (
                                <input type="text" {...field}/>
                            )}
                        />
                    </div>
                </div>
                <br/>
                <input type="submit" value="Envoyer" style={{display: "block", margin: "auto"}}/>
            </form>
        </>
    );
}
